var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("flexbox", { staticClass: "cell" }, [
    _c("div", { staticClass: "cell-head" }, [
      _c("i", { class: _vm._f("wkIconPre")(_vm.type) }),
      _vm._v(" "),
      _c("span", [
        _vm._v("\n      " + _vm._s(`相关${_vm.typeName}-`) + "\n    "),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "cell-body text-one-line",
        class: { "cursor-pointer": _vm.cursorPointer },
        on: { click: _vm.bodyClick },
      },
      [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "cell-foot" }, [
      _vm.showFoot
        ? _c("a", { staticClass: "cancel-btn", on: { click: _vm.footClick } }, [
            _vm._v("取消关联"),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }